import React from "react";
import ReactDOM from "react-dom";

const App = () => {
    return <h1>Off-Business Orders App is Working!</h1>;
};

ReactDOM.render(<App />, document.getElementById("root"));

